
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { SidebarProvider } from "@/contexts/SidebarContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { ModalProvider } from "@/contexts/ModalContext";
import AppRouter from "@/components/AppRouter";
import AuthDebug from "@/components/AuthDebug";
import { NotificationProvider } from "./contexts/NotificationContext";
import AuthLinkError from "@/pages/AuthLinkError";

const queryClient = new QueryClient();

const App = () => {
  // Supabase sends auth errors as bare hash fragments: #error=access_denied&...
  // HashRouter can't match these as routes, so we handle them before mounting the router.
  if (window.location.hash.startsWith("#error=")) {
    return <AuthLinkError />;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <AuthProvider>
          <NotificationProvider>
            <SidebarProvider>
              <ModalProvider>
                <TooltipProvider>
                  <Toaster />
                  <Sonner />
                  <HashRouter>
                    <AppRouter />
                  </HashRouter>
                  {/* <AuthDebug /> */}
                </TooltipProvider>
              </ModalProvider>
            </SidebarProvider>
          </NotificationProvider>
        </AuthProvider>
      </LanguageProvider>
    </QueryClientProvider>
  );
};

export default App;
